export default __webpack_public_path__ + "assets/images/platforms/031b4eb738d5c36e6d52a2fc0bc271d0.png";